import React from 'react';
import { withStyles, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      padding: theme.spacing(2),
    },
  })
);

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}))(TableRow);

function createData(val, tax, tax2) {
  val = val.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  tax = tax.split("¥n").map((line, key) => <span key={key}>{line}<br /></span>);
  tax2 = tax2.split("¥n").map((line, key) => <span key={key}>{line}</span>);
  return { val, tax, tax2 };
}

const flyerRows = [
  createData('B4判以下', '3.96円（税抜3.6円）', '4.73円（税抜4.3円）'),
  createData('B3判', '6.05円（税抜5.5円）', '7.04円（税抜6.4円）'),
  createData('B2判', '11.55円（税抜10.5円）', '12.65円（税抜11.5円）'),
  createData('B1判', '22.0円（税抜20.0円）', '24.86円（税抜22.6円）'),
  createData('ハガキ', '4.62円（税抜4.2円）', '4.62円（税抜4.2円）'),
];

function Flyer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込広告のご案内
          </Typography>
          　折込広告は、新聞とともに毎日各家庭に配達される、安心で確実な媒体です。そこに盛り込まれる商品情報は、消費者にとって欠かすことのできない生活情報です。デーリー東北折込センターでは、当社新聞販売店網を活用し、ご希望の地域読者に速やかに確実にお届けします。また<a href="https://www.pressnet.or.jp/outline/advertisement/" target="_blank">「新聞折込広告基準」</a>に従い信頼される折込広告を心掛けております。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/flyerdetail" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  折込広告　詳細
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/2026orikomi_shimekiri-003.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  折込締切カレンダー
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/digitalflyer" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  デジタルチラシ掲載
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/2025orikomi_busuu-001.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  折込広告取扱部数表
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/2025orikomi_moushikomi-001.pdf" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  折込広告申込書（PDF）
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/2025orikomi_moushikomi-001.xls" className="px-4 m-2 d-block" size="large" themeColor={teal}>
                  折込広告申込書（Excel）
                </CustomButton>
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomButton href="/pdf/flyer/2025orikomi_onestop.xlsx" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  折込ワンストップサービス料金表
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込広告のメリット
          </Typography>
          <dl>
            <dt>低予算</dt>
            <dd>
              サイズ、配布エリア、部数（１０部より）が選べるので、低予算で効率的に広告できます。
            </dd>
            <dt>信頼性</dt>
            <dd>
              新聞とともに毎日各家庭に確実に配達され、さらに<a href="https://www.pressnet.or.jp/outline/advertisement/" target="_blank">「新聞折込広告基準」</a>に従い、信頼される折込広告を心掛けております。また、保存できるので、持続効果もあります。
            </dd>
            <dt>表現力</dt>
            <dd>
              デザイン、紙質、サイズ等制限が少なく、より多くの情報を届けられます。
            </dd>
            <dt>適時性</dt>
            <dd>
              折込日を自由に選べます。（<a href="/flyerdetail#holiday" target="_blank">休刊日</a>は除く）
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            新聞折込料金（税込）
          </Typography>
          <Grid spacing={0} container direction="row" justify="center" className="text-center">
            <Grid item xs={12} md={10} className="p-2">
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="center" rowSpan="2">種類</StyledTableCell>
                      <StyledTableCell align="center" colSpan="2">料金</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell align="center">青森県</StyledTableCell>
                      <StyledTableCell align="center">岩手県</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {flyerRows.map(row => (
                      <StyledTableRow key={row.val}>
                        <StyledTableCell component="th" scope="row" align="center">
                          {row.val}
                        </StyledTableCell>
                        <StyledTableCell align="center">{row.tax}</StyledTableCell>
                        <StyledTableCell align="center">{row.tax2}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込広告のエリア
          </Typography>
          <dl>
            <dt>青森県内</dt>
            <dd>
              八戸市、三沢市、十和田市、青森市、三戸郡、上北郡
            </dd>
            <dt>岩手県内</dt>
            <dd>
              二戸市、久慈市、洋野町、軽米町、九戸村
            </dd>
          </dl>
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            締切日
          </Typography>
          <dl>
            <dt>折込日の３日前　午後４時</dt>
            <dd>
              ※但し土・日・祝日を除く営業日換算
            </dd>
          </dl>
          【折込日の例】<br/>
          <span className="fs150 text-danger font-weight-bold">金曜日</span>　折込の場合　→　<span className="fs150 text-danger font-weight-bold">火曜日</span>　申し込み・チラシ搬入締切
        </Box>

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            お問い合わせ
          </Typography>
          <dl>
            <dt>デーリー東北新聞社 読者局 折込開発部（折込センター）</dt>
            <dd>
              〒031-0072　青森県八戸市城下二丁目４－４<br/>
              <PhoneEnabledIcon /> 0178-46-3195<br/>
              <i className="fas fa-fax mx-1"></i> 0178-44-1734<br/>
              <MailOutlineIcon /> <a href="mailto:orikomi@daily-tohoku.co.jp">orikomi@daily-tohoku.co.jp</a>
            </dd>
          </dl>
        </Box>

      </div>
    </div>
  );
}

export default Flyer;
